import { AuthenticationContext, adalFetch, withAdalLogin } from './components/react-adal/src/react-adal';

console.log("Redirect URL: " + process.env.REACT_APP_REDIRECTURL);

export const adalConfig = {
    tenant: '33790e7d-c19e-41fd-8fd6-1f1e9064c7f2',
    clientId: process.env.REACT_APP_CLIENTID,
    endpoints: {
        api: 'https://graph.microsoft.com',
    },
    postLogoutRedirectUri: window.location.origin,
    redirectUri: process.env.REACT_APP_REDIRECTURL,
    cacheLocation: 'localStorage',
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) => {
    console.log('token', getToken());
    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options)
};

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);

export const getToken = () => {
    return authContext.getCachedToken(authContext.config.clientId);
};



// WEBPACK FOOTER //
// ./src/adalConfig.js